import { useTranslation } from "react-i18next";

import i18n from "i18next";

import { useContentSelectors } from "../../../../../store/content/content.selectors";

import ProxyItem from "./components/ProxyItem";

import {
  ExploreLink,
  Icon,
  ProxyList,
  Title,
  Wrapper,
} from "./PersonalProxies.styled";

export const PersonalProxies = () => {
  const { t } = useTranslation();
  const currentLanguage = i18n.language;
  const homePath = currentLanguage === "en" ? "/" : `/${currentLanguage}`;

  const { menuProxies } = useContentSelectors();

  return (
    <Wrapper>
      <Title>{t("blog.personalProxies")}</Title>
      <ProxyList>
        {menuProxies?.map(el => (
          <ProxyItem key={el?.id} el={el} />
        ))}

        <ExploreLink to={homePath}>
          <p>{t("blog.explore")}</p>
          <Icon src="/assets/svg/exploreArrow.svg" alt="arrow" />
        </ExploreLink>
      </ProxyList>
    </Wrapper>
  );
};
